import script from "./VinMaskRulePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./VinMaskRulePanel.vue?vue&type=script&setup=true&lang=js"

import "./VinMaskRulePanel.vue?vue&type=style&index=0&id=67c996e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67c996e0"]])

export default __exports__